import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  borderRadius: '.5rem',
  gap: '2rem',
  padding: '1.5rem',
  maxWidth: '20rem',

  [theme.breakpoints.up('sm')]: {
    padding: '1rem',
    maxWidth: '100%',
  },
  [theme.breakpoints.up('md')]: {
    minWidth: '35rem',
  },
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1.2rem',
  padding: '.9rem',
  backgroundColor: `${theme.palette.primary.main}`,
  marginBottom: '1rem',
}));

export const FiltersContainer = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '0',
  zIndex: 1,
  backgroundColor: theme.palette.primary.main,
}));

export const changeValuePaperPropsStyle = {
  style: {
    backgroundColor: 'transparent',
    maxWidth: '35rem',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '37.5rem',
    },
  },
};

export const StyledCloseIcon = styled(CloseIcon)(() => ({
  marginBottom: '1rem',
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const AlignButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '1rem',
  flexDirection: 'column',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignSelf: 'self-end',
  },
}));
